<template>
  <div>
    <div class="row">
      <div class="col">
        <h5 class="float-left">3.4B Land Information</h5>
<!--        <div class="float-right mb-1">-->
<!--          <div v-if="lands.length > 0">-->
<!--            <span class="badge badge-success mr-2">Total Search Data Found: {{ lands.length }}</span>-->
<!--            <download-excel-->
<!--                    class = "btn btn-light"-->
<!--                    :data = "lands"-->
<!--                    :fields = "land_fields"-->
<!--                    :meta="json_meta"-->
<!--                    worksheet = "Land"-->
<!--                    name = "land.xls">-->
<!--              Download Excel-->
<!--            </download-excel>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <p v-if="lands.length === 0">N/A</p>
    <div class="scrollable-table" v-if="lands.length > 0">
      <table class="table table-bordered table-hover dt-table table-striped table-long table-sm">
        <thead>
          <tr>
            <th>#</th>
            <th>land Type</th>
            <th>Mouza</th>
            <th>Plot No.</th>
            <th>Khatian No</th>
            <th>Total Land</th>
            <th>Aquired Land</th>
            <th>Land Ownership</th>
            <th>LA Case</th>
          </tr>
        </thead>
        <tbody>
          <tr li v-for="(land, index) in lands" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ land.land_type.desc }}</td>
            <td>{{ land.mouza.desc }}</td>
            <td>{{ land.plot_no }}</td>
            <td>{{ land.khatian_no }}</td>
            <td>{{ land.total_land }}</td>
            <td>{{ land.acquired_land }}</td>
            <td>{{ land.land_ownership.desc }}</td>
            <td><span v-if="land.la_case">{{ land.la_case.desc }}</span><span v-else></span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import http from "@state/http";

export default {
  data() {
    return {
      lands: [],
      land_fields: {
        'land Type': 'land_type.desc',
        'Mouza': 'mouza.desc',
        'Plot No.': 'plot_no',
        'Khatian No': 'khatian_no',
        'Total Land': 'total_land',
        'Aquired Land': 'acquired_land',
        'Land Ownership': 'land_ownership.desc',
        'LA Case' : {
          callback: (value) => {

            return `${value.la_case ? value.la_case.desc : ''}`;
          }
        },
        'CCL Amount': 'ccl_amount',
        'Book/Sub Book' : {
          callback: (value) => {
            return `${value.book_no} / ${value.book_sub_no}`;
          }
        },
        'Cheque No.': 'cheque_no',
        'Cheque Date': 'cheque_date',
      },
      json_meta: [
        [
          {
            'key': 'charset',
            'value': 'utf-8'
          }
        ]
      ],
    };
  },

  mounted() {
    this.getPersonLands();
  },
  methods: {
    getPersonLands() {
      http
        .get("api/ses/land/household/person-lands/" + this.$route.params.ses_id)
        .then(response => {
          if (!response.error) {
            this.lands = response.data.land;
          }
        });
    }
  },
};
</script>
